var map = {
	"./course1.png": 2313,
	"./course2.png": 1936,
	"./course3.png": 2424,
	"./course4.png": 9102,
	"./course5.png": 3744,
	"./course6.png": 3030,
	"./course7.png": 6689,
	"./course8.png": 7215,
	"./course9.png": 6448
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4794;